const envelopeField = value => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return String(value);
};
export const parseErrorEnvelope = function parseErrorEnvelope() {
  let envelope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    message: envelopeField(envelope.error_msg),
    hint: envelopeField(envelope.error_hint),
    technicalDetail: envelopeField(envelope.error_detail),
    reference: envelopeField(envelope.trace_id),
    errorCode: envelopeField(envelope.error_code)
  };
};
export const getErrorMessage = function getErrorMessage() {
  let envelope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return parseErrorEnvelope(envelope).message;
};